// react
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// material-ui icons
import CreditCard from "@material-ui/icons/CreditCard";
import Event from "@material-ui/icons/Event";

// material-ui components
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import NavPills from "beaktShared/components/NavPills/NavPills.js";
import Clearfix from 'beaktShared/components/Clearfix/Clearfix';
import PedidoCompraPagamentoCartao from 'beaktClinic/views/Estoque/Pagamentos/PedidoCompraPagamentoCartao';
import PedidoCompraPagamentoDeposito from 'beaktClinic/views/Estoque/Pagamentos/PedidoCompraPagamentoDeposito';

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// services
import { UsePostApi } from "beaktShared/services/crudeApiService";
import { transformValueFormatedtoFloat, transformValueFloattoFormated } from "beaktShared/helpers/masks";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoVenda.js";
const useStyles = makeStyles(styles);

export default function PedidoCompraPagamento({pedidocompra}) {
  const { t } = useTranslation(); 
  const classes = useStyles();  
        
  const [loading,setloading] = React.useState(false);

  const [messageReturn,setmessageReturn]= React.useState({
    show:false,
    message:''
  });
  
  const [alert,setalert] = React.useState();

  const showAlert = (message, tipo, reload) => {    
    console.log(message)         
    setalert(<SweetAlert
      warning={tipo=='warning'?true:false}
      success={tipo=='success'?true:false}
      title={t('label.warning')}
      onConfirm={() => (reload ? window.location.reload() : setalert(null))}
    >  
    <div dangerouslySetInnerHTML={{ __html: message}} /> 
    </SweetAlert> );
  };
  
  const [tabsPagamento, settabsPagamento] = React.useState([]);
  const [pgto, setpgto] = React.useState({      
    pedidoCOmpraPagamentoCartoes:[],
    pedidoCompraPagamentoDepositos:[],
    totalizadorPagamentos:{
      valorTotalPago: 0,
      valorPendente:pedidocompra.totalPedido,
    }
  });

  const handleRemovePg = (item, tipo) =>{
    if (tipo === "Cartão")
    {
        let listFiltered = pgto.pedidoCOmpraPagamentoCartoes.filter(obj => {
            return obj.id !== item.id;
        });    
        let updatepgto = {
            ...pgto,
            pedidoCOmpraPagamentoCartoes: listFiltered
        }    
        loadTotalizadorPgtos(updatepgto);
    }   
    else{
        let listFiltered = pgto.pedidoCompraPagamentoDepositos.filter(obj => {
            return obj.id !== item.id;
        });    
        let updatepgto = {
            ...pgto,
            pedidoCompraPagamentoDepositos: listFiltered
        }    
        loadTotalizadorPgtos(updatepgto);
    } 
  }

  const loadTotalizadorPgtos = (pgto) =>{
        let valorPago = 0;
        pgto.pedidoCOmpraPagamentoCartoes.map(item =>{
            valorPago = valorPago + item.valor;
        });

        pgto.pedidoCompraPagamentoDepositos.map(item =>{
            valorPago = valorPago + item.valor;
        });

        let valorSaldoPendente = pedidocompra.totalPedido - valorPago;
        valorSaldoPendente = (valorSaldoPendente).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        valorSaldoPendente = transformValueFormatedtoFloat(valorSaldoPendente);

        let updatepgto ={
            ...pgto,        
            totalizadorPagamentos:{
                valorTotalPago: valorPago,
                valorPendente:valorSaldoPendente,
            }
        };
        
        setpgto(updatepgto);
        return updatepgto;
  }

  const loadTabsFormasPagamento = () => {
    let tabs = [];
        tabs.push({                    
        tabButton: t('sale.card'),
        tabIcon: CreditCard,
        tabContent: (
          <div> 
              <PedidoCompraPagamentoCartao CallloadTotalizadorPgtos={loadTotalizadorPgtos} pgto={pgto}></PedidoCompraPagamentoCartao>
          </div>
        )
      });

      tabs.push({
        tabButton: t('sale.deposit'),
        tabIcon: Event,
        tabContent: (
        <div>
            <PedidoCompraPagamentoDeposito CallloadTotalizadorPgtos={loadTotalizadorPgtos} pgto={pgto}></PedidoCompraPagamentoDeposito>
        </div>
        )          
      });
      settabsPagamento(tabs);
  }

  useEffect(() => {       
    loadTabsFormasPagamento();
  }, []);    

  useEffect(() => {              
    setmessageFinalizaReturn({show:false})
    loadTabsFormasPagamento();
  }, [pgto]);

  const [messageFinalizaReturn,setmessageFinalizaReturn]= React.useState({
    show:false,
    message:''
  });

  const handleFinalizaCompra = () => {
    if(pgto.totalizadorPagamentos.valorPendente !== 0)
    {
      setmessageFinalizaReturn({
        show:true,
        message:t('error_message.the_value_to_pay_must_be_zeroed')+"!"
      }); 
      return false;
    }

    pedidocompra.pedidoCOmpraPagamentoCartoes = pgto.pedidoCOmpraPagamentoCartoes;
    pedidocompra.PedidoCompraPagamentoDepositos = pgto.pedidoCompraPagamentoDepositos;
    pedidocompra.PagamentoEfetuado = 1;

    setloading(true);
    UsePostApi("pedidocompra", pedidocompra).then(result => {
        setloading(false);
        if (result.status !== 200) {
            showAlert(result.message, "error", false);
            return false;
        }            
        showAlert(t('stock.purchase_order_generated_sucessfully')+"!", "success", true);                            
        return true;
    });
  };

return (    
    <div className="maxContent">    

        {alert}
        {loading && 
          <div className="carregandoCmp">
              <div className="box">
                <label>{t('label.loading')}...</label>
                <CircularProgress />
              </div>
          </div> 
        }
        
        <GridContainer>
           
            <GridItem xs={12} sm={8} md={8}>
            <Card>
            <CardBody>    
               
               <h3>{t('sale.payment_methods')}</h3>

              <div style={{maxWidth:'700px',margin:'0 auto'}}>
               <NavPills
                color="primary"
                alignCenter
                tabs={tabsPagamento}
              />
              </div>
              {messageReturn.show &&
                <div><div className="alertErrorEx alertmax">
                  <p>
                  {messageReturn.message}   
                  </p>
                </div><br/></div>
              }
            </CardBody>
            </Card>  
            </GridItem>            
            <GridItem xs={12} sm={4} md={4}>
            <Card>
            <CardBody>    
               
               <h4>{t('sale.payments_made')}</h4>

               {pgto.pedidoCOmpraPagamentoCartoes.map(item => (  
                 <div key={item.id}> 
                   <div className={classes.boxItemPg}>
                      <div className={classes.descForma}>
                        {item.descTipo}
                      </div>
                      <div className={classes.valuePg}>
                        <small>{t('label.money_symbol')}</small> {transformValueFloattoFormated(item.valor)} <small> ({item.descPacela})</small>  
                      </div>                                      
                      <div className={classes.rmvPg}>
                      <a  href="#"  onClick={() => handleRemovePg(item, "Cartão")}>
                      {t('button.remove')}
                      </a>
                      </div>               
                    </div> 
                    <br/>  
                    </div> 
                ))}

                {pgto.pedidoCompraPagamentoDepositos.map(item => (  
                 <div key={item.id}> 
                   <div className={classes.boxItemPg}>
                      <div className={classes.descForma}>
                      {t('sale.deposit')}
                      </div>
                      <div className={classes.valuePg}>
                        <small>{t('label.money_symbol')}</small> {transformValueFloattoFormated(item.valor)}
                      </div>                                      
                      <div className={classes.rmvPg}>
                      <a  href="#"  onClick={() => handleRemovePg(item, "Depósito")}>
                        {t('button.remove')}
                      </a>
                      </div>               
                    </div> 
                    <br/>  
                    </div> 
                ))}
                
                <br/>
              <div className={classes.boxTotalizador}>
                {t('stock.total_order')} 
                <div className={classes.valueTotalizador}>
                {t('label.money_symbol')} {transformValueFloattoFormated(pedidocompra.totalPedido)} 
                </div>
                <Clearfix/>
              </div>
              <div className={classes.boxTotalizador}>
                 {t('sale.total_payments')} 
                <div className={classes.valueTotalizador}>
                {t('label.money_symbol')} {transformValueFloattoFormated(pgto.totalizadorPagamentos.valorTotalPago)} 
                </div>
                <Clearfix/>
              </div>
              <div className={classes.boxPendencia}>
                 {t('sale.balance_to_pay')}
                <div className={classes.valuePendencia}>
                {t('label.money_symbol')} {transformValueFloattoFormated(pgto.totalizadorPagamentos.valorPendente)} 
                </div>
              </div>  

                <GridItem xs={12} sm={12} md={12}>      
                    {messageFinalizaReturn.show &&
                    <div><div className="alertErrorEx alertmax">
                        <p>
                        {messageFinalizaReturn.message}   
                        </p>
                    </div><br/>
                    </div>
                    }                                                      
                    <div className={classes.tCenter}>
                        <Button fullWidth color="info" onClick={() => handleFinalizaCompra()}>
                         {t('stock.finish_order')}          
                        </Button>
                    </div>
                </GridItem>                    
            </CardBody>
            </Card>  
            </GridItem>

        </GridContainer>
    </div>
);
}